<template>
  <custom-dialog width="500px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <!-- 用户信息 -->
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item :label="$t('base_func_item_dialog.suo_shu_ying_yong')" prop="appId">
          <el-select disabled v-model="form.appId" @change="changeApp()">
            <el-option v-for="item in appList" :key="item.appId" :label="item.appName" :value="item.appId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('base_func_item_dialog.shang_ji_gong_neng')">
          <custom-select
            v-model="form.parentId"
            :props="{ label: 'funcName', value: 'funcId', checkStrictly: true }"
            type="tree"
            url="FuncTree"
            :show-all-levels="false"
            :params="{ appId: form.appId, funcId: funcId, funcType: 2 }"
          ></custom-select>
        </el-form-item>
        <el-form-item :label="$t('base_func_item_dialog.gong_neng_ming_cheng')" prop="funcName">
          <el-input v-model="form.funcName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('base_func_item_dialog.gong_neng_dai_ma')" prop="funcCode">
          <el-input v-model="form.funcCode"></el-input>
        </el-form-item>
        <el-form-item :label="$t('base_func_item_dialog.gong_neng_lei_xing')" prop="funcType">
          <custom-select v-model="form.funcType" code="bas_function_type" value-type="number"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('base_func_item_dialog.duo_yu_yan_dai_ma')" prop="langFuncName">
          <el-input v-model="form.langFuncName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('base_func_item_dialog.xian_shi_shun_xu')" prop="showOrder">
          <el-input type="number" :min="0" v-model.number="form.showOrder"></el-input>
        </el-form-item>
        <el-form-item :label="$t('base_func_item_dialog.shi_fou_qi_yong')" prop="state">
          <el-switch v-model="form.state" :active-value="1" :inactive-value="2"></el-switch>
        </el-form-item>
        <el-form-item :label="$t('base_func_item_dialog.gong_neng_miao_shu')" prop="funcDesc">
          <el-input type="textarea" :rows="2" v-model="form.funcDesc"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="savFuncItem">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      appList: [],
      appTree: [],
      funcId: '',
      form: {
        appId: '',
        funcId: '',
        funcCode: '',
        funcDesc: '',
        funcName: '',
        funcType: '',
        langFuncName: '',
        showOrder: 0,
        parentId: null,
        state: 1,
      },
    };
  },
  computed: {
    rules() {
      return {
        appId: {
          required: true,
          message: this.$t('base_func_item_dialog.ssyyidbt'),
        },
        funcName: [
          {
            required: true,
            message: this.$t('base_func_item_dialog.gnmcbt'),
          },
          { max: 20, message: this.$t('Common.com_rules_length_max', [20]), },
        ],
        funcCode: {
          required: true,
          message: this.$t('base_func_item_dialog.gndmbt'),
        },
        langFuncName: [
          {
            required: true,
            message: this.$t('base_func_item_dialog.dyydmbt'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]), },
        ],
        funcType: {
          required: true,
          message: this.$t('base_func_item_dialog.gnlxbt'),
        },
        showOrder: {
          type: 'number',
          min: 0,
          message: this.$t('Common.com_rules_number_min', [0]),
        },
        state: {
          type: 'number',
          required: true,
          message: this.$t('base_func_item_dialog.qxzsfqy'),
        },
        funcDesc: { max: 50, message: this.$t('Common.com_rules_length_max', [50]), },
      };
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.appTree = [];
      this.appList = [];
      this.funcId = '';
      this.getAppList();
      if (this.model.type === 'add') {
        this.form.appId = this.model.data.appId; // 所属应用
        this.getAppTree();
      }
      if (this.model.type === 'edit') {
        const row = this.model.data.item;
        row.parentId = row.parentId === this.model.data.appId ? null : row.parentId;
        row.appId = this.model.data.appId;
        this.funcId = row.funcId;
        this.$setFormatData(this.form, row);
        this.getAppTree();
      }
    },
    // 下拉树配置
    normalizer(node) {
      return {
        id: node.funcId,
        label: node.funcName,
      };
    },
    getAppList: function () {
      this.$getJSON(apis.AppMenu).then((res) => {
        this.appList = res.data;
      });
    },
    changeApp: function () {
      this.getAppTree();
      this.form.parentId = null;
    },
    // 获取平台树
    getAppTree: function () {
      this.$getJSON(apis.FuncTree, {
        appId: this.form.appId,
        funcId: this.funcId,
        funcType: 2,
      }).then((res) => {
        this.appTree = res.data || [];
      });
    },
    getParentId(ret) {
      if (Array.isArray(ret.parentId)) {
        const len = Math.max(0, ret.parentId.length - 1);
        return ret.parentId[len];
      }
      return ret.parentId;
    },
    getReqData() {
      const ret = {
        ...this.form,
      };
      ret.parentId = this.getParentId(ret);
      return ret;
    },
    savFuncItem: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'add') {
          this.saveAddFuncItem();
        }
        if (this.model.type === 'edit') {
          this.saveEditFuncItem();
        }
      });
    },
    // 保存新增
    saveAddFuncItem: function () {
      this.$postJSON(apis.FuncAdd, this.getReqData(), true).then(() => {
        this.$message({
          message: this.$t('Common.com_add_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
    // 保存编辑
    saveEditFuncItem: function () {
      this.form.funcId = this.funcId;
      this.$postJSON(apis.FuncUpdate, this.getReqData(), true).then(() => {
        this.$message({
          message: this.$t('Common.com_edit_success'),
          type: 'success',
        });
        this.visible = false;
        this.$emit('success', this.form);
      });
    },
  },
};
</script>

<style lang="scss"></style>
